
import StylesMixin from '../../../../../mixins/styles';
import { CardProperty } from './enums';
import { ControlEventType } from '../../enums';
import StyleClassNamesBuilder from '../../../../../styles/helpers/StyleClassNamesBuilder';
import CardsProps from './mixins/CardProps';

export default {
  name: 'Card',
  mixins: [
    StylesMixin,
    CardsProps,
  ],
  data() {
    return {
      CardProperty,
    };
  },
  computed: {
    cardClassNames() {
      return new StyleClassNamesBuilder(this.rootClassName)
        .addConditionClassName('active', this[CardProperty.IsActive])
        .addConditionClassName('disabled', this[CardProperty.Disabled])
        .build();
    },
  },
  methods: {
    handleChange() {
      this.$emit(ControlEventType.Change, this[CardProperty.Value]);
    },
  },
};
